import { DateTime, Duration, Interval, Settings } from "luxon";
export { Duration as LuxDuration, DateTime as LuxDt, Settings as LuxSettings, Interval as LuxInt };
export const dtFromIso = (dtStr) => {
    if (!dtStr)
        return;
    return DateTime.fromISO(dtStr);
};
export const dtFromFmt = (dtStr, formatStr) => {
    return DateTime.fromFormat(dtStr, formatStr);
};
